import { Card, theme } from "antd";
import { ReactNode } from "react";

export type CardVariant = "default" | "grey";

export interface StandardCardProps {
  title?: ReactNode;
  children: ReactNode;
  variant?: CardVariant;
  style?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  headerStyle?: React.CSSProperties;
  className?: string;
}

export const StandardCard: React.FC<StandardCardProps> = ({
  title = "Properties",
  children,
  variant = "default",
  style,
  bodyStyle,
  headerStyle,
  className,
}) => {
  const { token } = theme.useToken();

  const backgroundColor =
    variant === "grey" ? token.colorBgLayout : token.colorBgContainer;

  return (
    <Card
      title={title}
      size="default"
      className={className}
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor,
        borderRadius: token.borderRadius,
        boxShadow: token.boxShadowTertiary,
        ...style,
      }}
      headStyle={{
        padding: "8px 12px",
        minHeight: "40px",
        fontSize: "14px",
        fontWeight: 500,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        backgroundColor,
        color: token.colorText,
        ...headerStyle,
      }}
      bodyStyle={{
        flex: 1,
        padding: "12px 0px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        backgroundColor,
        color: token.colorText,
        ...bodyStyle,
      }}
    >
      {children}
    </Card>
  );
};
